<template>
	<div class="">
		<Top></Top>
		<div class="wd-container error ">
			<div class="wd-flex wd-row-around error2">
				<div>
					<div class="title">哎呀</div>
					<div class="subtitle">页面丢失了！</div>
					<div class="content">您正在寻找的页面被移动、移除、重命名或不存在.</div>
					<div class="btn">
						<el-button type="primary" @click="gotohome">返回首页</el-button>
					</div>
				</div>
				<div>
					<el-image src="../img/404.gif"></el-image>
				</div>
			</div>
		</div>
		<Footer></Footer>
		</div>
</template>

<script>
	import Top from '@/components/layout/Top.vue';
	import Footer from '@/components/layout/Footer.vue';
	export default {
		name: 'Error',
		components: {
			Top,
			Footer
		},
		methods:{
			gotohome(){
				this.$router.push({path:'/'})
			}
		}
	}
</script>

<style lang="scss" scoped>
		.error{
			background-color:#373740 ;
			.error2{
				margin: 20px 0;
				.title{
					font-size: 60px;
					font-weight: 600;
					color: #f4ffa5;
				}
				.subtitle{
					font-size: 40px;
					font-weight: 600;
					color: #FFFFFF;
					margin-top: 20px;
				}
				.content{
					font-size: 16px;
					color: #FFFFFF;
					margin-top: 20px;
				}
				.btn{
					margin-top: 20px;
				}
			}
		}
</style>
